import accountPage from "./accountPage";
import authPage from "./authPage";
import dashboardPage from "./dashboardPage";
import dialogs from "./dialogs";
import direction from "./direction";
import errorPage from "./errorPage";
import giftsPage from "./giftsPage";
import header from "./header";
import operationsPage from "./operationPage";
import orderPage from "./orderPage";
import pageTitles from "./pageTitles";
import pricesPage from "./pricesPage";
import ticketsPage from "./ticketPage";
import transactionsPage from "./transactionsPage";
import walletPage from "./walletPage";
import notificationDrawer from "./notificationDrawer";
import captcha from "./captcha";
import fiatPage from "./fiatPage";
import bankCard from "./bankCard";
import orderProcessPage from "./orderProcessPage";
import cropper from "./cropper";
import otpOrder from "./otpOrder";
import tradingView from "./tradingView";
import referral from "./referral";
import languages from "./languages";
import market from "./Market/market";
import withdraw from "@/locales/ar/Market/withdraw";
import marketsPage from "@/locales/ar/Market/marketsPage";
import exchange from "@/locales/ar/Market/exchange";
import seo from "./seo";

export default {
  languages,
  accountPage,
  authPage,
  dashboardPage,
  dialogs,
  direction,
  errorPage,
  giftsPage,
  header,
  operationsPage,
  orderPage,
  pageTitles,
  pricesPage,
  ticketsPage,
  transactionsPage,
  walletPage,
  notificationDrawer,
  captcha,
  fiatPage,
  bankCard,
  orderProcessPage,
  cropper,
  otpOrder,
  tradingView,
  referral,
  market,
  withdraw,
  marketsPage,
  exchange,
  seo
};
